<template>
  <v-container grid-list-xl class="px-5">
    <m-card-list
      two-line
      title="Kelola Konfigurasi Modul"
      :items="items"
      :headers="headers"
      :page="page"
      :add="isCreate"
      :generateUser="true"
      search
      footer
      refresh
      @refresh="load"
      @add="onAdd"
      @toGenerate="toUpload"
      @search="
        (search) => {
          keyword = search
          load()
        }
      "
      @change:page="
        (pg) => {
          cp = pg
          load()
        }
      "
    >
      <template v-slot:action_ext>
        <v-tooltip v-if="tenant_id && key === 'is_blokir_finpay'" top>
          <template v-slot:activator="{ on }">
            <v-btn class="rounded ml-3 pa-5 grey lighten-3" icon depressed small v-on="on" @click="onResetKonfig">
              <v-icon>mdi-file-refresh-outline</v-icon>
            </v-btn>
          </template>
          <span>
            Reset Konfigurasi
          </span>
        </v-tooltip>
      </template>
      <template v-slot:action_tools>
        <v-select
          class="mt-6 mr-2"
          v-model="key"
          :items="keyList"
          dense
          outlined
          item-text="value"
          item-value="key"
          placeholder="Pilih Status"
          style="max-width: 270px"
          @change="changeList"
        >
        </v-select>
        <v-select
          class="mt-6 mr-2"
          v-model="tenant_id"
          :items="tenants"
          dense
          outlined
          item-text="nama"
          item-value="tenant_id"
          placeholder="Pilih Tenant"
          style="max-width: 150px"
          @change="load"
        >
        </v-select>
      </template>
      <template v-slot:items="{ props, item }">
        <tr>
          <td>
            {{ pVal(item, 'nama') }} <span class="caption grey--text"> ({{ pVal(item, 'no_reg') }})</span><br />
          </td>
          <td>
            {{ pVal(item.tenants, 'nama') }}
            <span class="caption grey--text"> ({{ pVal(item.tenants, 'no_reg') }})</span>
          </td>
          <td>
            <div class="text-center">
              <template v-if="item.konfigurasis && item.konfigurasis.length">
                <div v-for="i in item.konfigurasis" :key="i">
                  <template v-if="valueTrue.includes(key)">
                    <v-icon :color="i.value == 1 ? 'success' : 'red'">{{
                      i.value == 1 ? 'mdi-check-circle' : 'mdi-close-circle'
                    }}</v-icon>
                  </template>
                  <template v-else>
                    <v-icon :color="i.value == 1 ? 'red' : 'success'">{{
                      i.value == 1 ? 'mdi-close-circle' : 'mdi-check-circle'
                    }}</v-icon>
                  </template>
                </div>
              </template>
            </div>
          </td>
          <td>
            <m-menu left style="float: right" :items="more_menu" :object="item" />
          </td>
        </tr>
      </template>
    </m-card-list>
    <ChangeDlg ref="dlg" :tenants="tenants" @reload="load" />
    <FormUpload ref="upload" :max="1500" :tenants="tenants" @download="onDownloadTemplate" @reload="load" />
    <FormReset ref="reset" @reload="load" />
  </v-container>
</template>

<script>
import ChangeDlg from '../components/FormAksesKonfigurasi.vue'
import BlockCard from '@/components/BlockCard'
import FormUpload from '../components/Upload.vue'
import FormReset from '../components/FormReset.vue'
import { arrayToObject } from '@/tools'

export default {
  components: {
    ChangeDlg,
    BlockCard,
    FormUpload,
    FormReset,
  },
  data() {
    return {
      items: [],
      page: null,
      cp: 1,
      detail: {},
      keyword: '',
      key: 'is_blokir_finpay',
      tenants: [],
      tenant_id: null,
      more_menu: [
        {
          title: 'Ubah',
          click: (i, o) => this.edit(o),
        },
      ],
      keyList: [
        {
          key: 'is_blokir_finpay',
          value: 'Blokir Pembayaran Finpay',
          label: 'Pembayaran Finpay',
        },
        {
          key: 'is_disable_ketidakhadiran',
          value: 'Disable Ketidakhadiran',
          label: 'Fitur Ketidakhadiran',
        },
        {
          key: 'is_blokir_registrasi_portal',
          value: 'Blokir Registrasi Portal',
          label: 'Blokir Registrasi Portal',
        },
        {
          key: 'is_minimal_klaim',
          value: 'Validasi Batas Klaim Presensi',
          label: 'Validasi Batas Klaim Presensi',
        },
        {
          key: 'is_enable_fitur_cuti',
          value: 'Menggunakan Fitur Leave Managemen',
          label: 'Menggunakan Fitur Leave Managemen',
        },
      ],
      total: 0,
    }
  },
  computed: {
    valueTrue() {
      return ['is_minimal_klaim', 'is_enable_fitur_cuti']
    },
    isCreate() {
      return ['is_blokir_registrasi_portal'].includes(this.key)
    },
    headers() {
      const obj = arrayToObject(this.keyList, 'key')
      return [
        { text: 'Organisasi', sortable: false, align: 'left', value: 'label' },
        { text: 'Tenant', sortable: false, align: 'left', value: 'akses' },
        { text: obj[this.key]['label'], sortable: false, align: 'center', value: 'status' },
        { text: 'Aksi', sortable: false },
      ]
    },
  },
  mounted() {
    this.load()
    this.getTenant()
  },
  methods: {
    changeList() {
      this.items = []
      this.cp = 1
      this.load()
    },
    load() {
      let params = { key: this.key, keyword: this.keyword || '', page: this.cp || 1 }
      if (this.tenant_id) params['tenant_id'] = this.tenant_id
      this.$store
        .dispatch('akses/getCfg', params)
        .then((res) => {
          this.total = (res && res.data && res.data.total) || 0
          this.items = (res && res.data && res.data.data) || {}
          this.page = res && res.data
        })
        .catch((e) => e)
    },
    async edit(item) {
      const resp = await this.$store.dispatch('akses/fetchCfg', { key_akses: this.key, no_reg: item.no_reg })
      this.detail = (resp && resp.data) || {}
      this.$refs.dlg.open(Object.assign({}, this.detail, { isEdit: true }))
    },
    search(textSearch) {
      this.$store
        .dispatch('akses/get', { search: textSearch })
        .then((res) => {
          this.items = res.data.data
        })
        .catch((e) => e)
    },
    onAdd() {
      this.$refs.dlg.open(Object.assign({}, { isEdit: false }))
    },
    getTenant() {
      this.$store
        .dispatch('tenant/get', { count: 100 })
        .then(({ data }) => {
          this.tenants = (data && data.data) || data || []
        })
        .catch((e) => e)
    },
    toUpload() {
      this.$refs.upload.open()

      this.$nextTick(() => {
        this.$refs.upload.reset()
      })
    },
    onDownloadTemplate() {
      window.open('https://cdn.siap.id/s3/masook/cetak/Template_Unggah_Simpatika.xlsx')
    },
    onResetKonfig() {
      this.$refs.reset.open({ key: this.key, tenant_id: this.tenant_id, total: this.total })
    },
  },
}
</script>
